import * as React from "react";
import { NumberInput, SelectInput } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { PeriodMonths } from "../../../Constants/Constant";
import * as YearList from "../../../Constants/YearList";
import { useState } from "react";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { AircraftUtilizationStatus } from "../../../../src/Enums/AircraftUtilizationStatus";

const AircraftUtilizationTTCreateForm = () => {
  const dataProvider = useAppDataProvider();

  const [customerList, setCustomerList] = useState([] as any);
  const [selectedCustomer, setselectedCustomer] = useState("" as any);
  const [acRegList, setAcRegList] = useState([] as any);
  const [selectedAcReg, setSelectedAcReg] = useState({} as any);

  React.useEffect(() => {
    GetCustomerList();
  }, []);

  const GetCustomerList = async () => {
    dataProvider
      .getList("customers/", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        let dataLength: number = response.data.length;
        setCustomerList([]);
        if (dataLength > 0) {
          let data = response.data;
          setCustomerList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    if (!selectedCustomer) return;
    dataProvider
      .getList("cdmaircraft/GetAllCdmFleetData", {
        filter: {
          contractStatus__in: ["Active", "Hold"],
          contractOwnerName__eq: selectedCustomer,
          isActive__eq: 1,
        },
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "id", order: "DESC" },
      })
      .then(response => {
        let data: any = response?.data;
        setAcRegList([]);
        if (data.length > 0) {
          setAcRegList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, [selectedCustomer]);

  const customerChangeEvent = e => {
    setselectedCustomer(e.target.value);
  };

  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <SelectInput
                      source="ownerCode"
                      choices={customerList}
                      optionText="customerName"
                      optionValue="ownerCode"
                      onChange={customerChangeEvent}
                      fullWidth
                    ></SelectInput>

                    <SelectInput
                      source="acRegId"
                      choices={acRegList}
                      optionText="acReg"
                      optionValue="id"
                      fullWidth
                      variant="outlined"
                      required
                      defaultValue={selectedAcReg?.id}
                    />
                  </Box>
                </Box>
              </Box>

              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <SelectInput
                    source="periodYear"
                    choices={YearList.default}
                    optionText="key"
                    optionValue="key"
                    fullWidth
                  ></SelectInput>

                  <SelectInput
                    source="periodMonth"
                    choices={PeriodMonths}
                    optionText="month"
                    optionValue="value"
                    fullWidth
                  ></SelectInput>
                </Box>
              </Box>

              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightCycle" label="FLIGHT CYCLE" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightHour" label="FLIGHT HOUR" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightMinute" label="FLIGHT MINUTE" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput
                    source="status"
                    label="Status"
                    fullWidth
                    disabled
                    defaultValue={AircraftUtilizationStatus.Accepted}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default AircraftUtilizationTTCreateForm;
